import {apiUrl} from './apiAmbiente';
import {useEffect,useState} from 'react';
import axios from 'axios';
import {CHAVE_SESSAO} from './sessaoUsuario';

export default function usePermissaoAuditoriaCC(clienteId) {
  const [permitido,setPermitido]=useState(false);
  useEffect(()=>{
    let ativo=true,sequencia=0;
    async function consultar(){
      const seq=++sequencia;
      try{
        const form=new FormData();form.set('token',sessionStorage.getItem(CHAVE_SESSAO)||'');
        const {data}=await axios.post(apiUrl('PermissoesUsuario.php'),form);
        if(ativo&&seq===sequencia)setPermitido(data?.ok===true&&data.pode_auditar_cc===true);
      }catch(_){if(ativo&&seq===sequencia)setPermitido(false);}
    }
    consultar();window.addEventListener('focus',consultar);
    return()=>{ativo=false;window.removeEventListener('focus',consultar);};
  },[clienteId]);
  return permitido;
}
